import {useDispatch} from 'react-redux';
import useEventPageEvent from './useEventPageEvent';
import {showAuthModal} from '../../common/function';
import useEvent from '../../common/hook/useEvent';
import useLogin from '../../common/hook/useLogin';
import {actions} from '../state/action';
import {IMissionParam} from '../type';

type Param = IMissionParam & {index?: number; disabled?: boolean};

export default function useEventHandleMission(): (params: Param) => void {
  const dispatch = useDispatch();
  const sendEventPageEvent = useEventPageEvent();
  const {isLogin, isLoginChecking} = useLogin();

  return useEvent(({actionName, customProps, index, disabled}: Param) => {
    if (isLoginChecking || disabled) return;

    if (isLogin) {
      sendEventPageEvent({actionName, customProps});
      dispatch(actions.fetchEventCollect({actionName, customProps}, index));
    } else {
      showAuthModal({isSaveReturnPage: true});
    }
  });
}
